import { takeLatest, call, put, select } from 'redux-saga/effects';
import uuid from 'uuid';
import { API_LINK } from '../../constants';
import { xapiRequest, xapiSuccess, xapiFailure } from '../reducers/xapi';
import {selectedProgram, selectedProgramId, selectedContentId, selectedContent, selectedModule} from '../selectors'
import axios from 'axios';

import gql from 'graphql-tag';
import moment from 'moment';
const graphql = require('graphql');

const { print } = graphql;

const GRAPHQL_ENDPOINT = "https://nzzjpexhc5ezxoya3e6lvwa2jm.appsync-api.us-east-1.amazonaws.com/graphql";
const GRAPHQL_API_KEY = "da2-r55u2hwcrvdmxp2zlnvcqx4r3a";
//const API = `https://wlndhhrq7ngovczqxasiyqkbna.appsync-api.us-east-1.amazonaws.com/graphql`;

function* xapiAxios() {
  const state = yield select(fullState => fullState);
  const { xapiType, type } = state.xapiReducer;



  const userReducer = state.loginReducer;
  const content = state.userProgramsFullReducer.item;
  let jsonPayload = null;


  const createEngagement = gql`
  mutation createEngagement($input: CreateEngagementInput!) {
         createEngagement(input: $input) {
          studentID
          idNumber
          email
          id
          type
          datetime
          firstName
          lastName
          demographics
          programName
          projectName
          rolloutName
          moduleName
          moduleStatus
          componentName
          componentStatus
          componentType
          user
          client
          id
         }
     }
  `
  let contentType = content && content.type;
  if(contentType === "Assignment"   ){
    contentType = "Assessment"
  }
  const user =  axios({
    url: GRAPHQL_ENDPOINT,
    method: 'post',
    headers: {
    'x-api-key':GRAPHQL_API_KEY
    },
    data:{
      query: print(createEngagement),
      variables: {
        input: {
        studentID: userReducer.user.userId,
        idNumber: userReducer.user.identityNo,
        email: userReducer.user.email,
        type: userReducer.user.admin ? xapiType+' -admin- '+userReducer.user.admin: xapiType,
        datetime: new Date().toISOString(),
        firstName: userReducer.user.firstName && userReducer.user.firstName,
        lastName: userReducer.user.lastName &&  userReducer.user.lastName,
        demographics: userReducer.user.demographics && JSON.stringify(userReducer.user.demographics),
        programName: selectedProgram(state) && selectedProgram(state).name+" ("+selectedProgram(state).programCode+")",
        projectName:selectedProgram(state) && selectedProgram(state).projectName+" ("+selectedProgram(state).projectCode+")",
        rolloutName: content && content.rolloutName,
        moduleName: content && content.moduleName+" ("+content.moduleCode+")",
        moduleStatus: selectedModule(state) && selectedModule(state).status,
        componentName:content && content.name+" ("+content.library_code+")",
        componentStatus: content && content.status,
        componentType: contentType && contentType,
        user: "Student",
        client: userReducer.user.clientName,
        id: moment().format('YYYYMMDDHHMMSS')  + uuid.v4()
      }
    }
    }
  })
  return user
}

function* workerXapiSaga() {
  try {
    const response = yield call(xapiAxios);
    const responseData = response.data;

    if (response.status === 200) {
      yield put(xapiSuccess(responseData));
    }
  } catch (error) {
    yield put(xapiFailure(error));
  }
}

export function* watcherXapiSaga() {
  yield takeLatest(xapiRequest().type, workerXapiSaga);
}
